module.exports = __webpack_public_path__ + "static/img/7.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/7.jpg
// module id = FYhk
// module chunks = 36